import clsx from "clsx";
import React, { useState } from "react";
import { amountCheck } from "./validation";
import { forecastingInputType } from "../../../../common/types/search/search";

interface ForecastAmountFieldProps {
	type: string;
	currentInput: forecastingInputType;
	onInputChange: (input: forecastingInputType) => void;
	valid: boolean;
	quickSearch?: boolean;
}

export function ForecastAmountField({
	type,
	currentInput,
	valid,
	onInputChange,
	quickSearch,
}: ForecastAmountFieldProps) {
	const [showValidation, setShowValidation] = useState(false);

	if (showValidation && currentInput.isEmpty()) {
		setShowValidation(false);
	}

	const amount = currentInput.get("amount", "");
	const errorMessage =
		(showValidation || !valid) && amountCheck(currentInput).getMessage();
	const error = errorMessage && (
		<span className="error-text">{errorMessage}</span>
	);
	const errorClasses = clsx("criterion__section", { error: errorMessage });

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onInputChange(currentInput.set("amount", e.target.value));
		setShowValidation(true);
	};

	return (
		<div className={errorClasses}>
			<div className="form-group form-group-inline">
				<label htmlFor="forecastAmount">Number of {type}</label>
				<input
					type="text"
					name="amount"
					value={amount}
					id={`forecastAmount${quickSearch ? "_quick_search" : ""}`}
					pattern="\d*"
					placeholder="0"
					data-criterion={true}
					onChange={onChange}
					onBlur={onChange}
				/>
			</div>
			{error}
		</div>
	);
}
